export const AUTH_TOKEN = "auth_token";
export const AUTH_DETAILS = "auth_details";
export const MENU_ITEMS = "menu_items";
export const AdminId = "admin_id"
export const STUDENT_STATUS_LIST = ['In Progress', 'On Hold', 'Cancelled', 'Arrived']
export const UNIVERSITY_DOC = [
  "Conditional Offer",
  "Unconditional Offer",
  "TT Confirmation Receipt",
  "Bursary Document",
  "COE/CAS/I20/LOA",
  "VISA : VISA Application Letter",
  "VISA Appointment Letter"
];
export const YEARS = [
  2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035,
  2036, 2037, 2038, 2039, 2040,
];
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July ",
  "August",
  "September",
  "October",
  "November",
  "December",
];
